module.exports = __webpack_public_path__ + "static/media/motomate.587d37db.gif";